module.exports = __webpack_public_path__ + "img/msg-buy.06ff13b3.svg";